import React, { useState } from "react";
import {
    Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Link } from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu';
import Settings from '@mui/icons-material/Settings'
import Toolbar from "@mui/material/Toolbar";
import { useTheme } from '@mui/material/styles';
import {GlobalStyle as gs} from '@src/GlobalStyle'

const useStyles = makeStyles(()=>({
    link:{
        textDecoration:"none",
        color: "#fff",
        fontSize: "20px",
    },
    icon:{
        color: "white"
    },
    right: {
      backgroundColor: gs.colors.bar
    }
}));

function DrawerComponent() {
  const classes = useStyles();
  const theme = useTheme()
  const [openDrawer, setOpenDrawer] = useState(false);
  return (
    <>
      <Drawer
        open={openDrawer}
        anchor={'right'}
        onClose={() => setOpenDrawer(false)}
        PaperProps={{
          className: classes.right,
          sx:{backgroundColor:'#000'}
        }}
      >
        <Toolbar />
        <List >
          <ListItem onClick={() => setOpenDrawer(false)}>
            <ListItemText>
              <Link to="/profile" className={classes.link}>My</Link>
            </ListItemText>
          </ListItem>
          <Divider/>
          <ListItem onClick={() => setOpenDrawer(false)}>
            <ListItemText>
              <Link to="/logout" className={classes.link}>로그아웃</Link>
            </ListItemText>
          </ListItem>
        </List>
      </Drawer>
      <IconButton onClick={() => setOpenDrawer(!openDrawer)} className={classes.icon}>
        <Settings sx={{color:'#fff'}}/>
      </IconButton>
    </>
  );
}
export default DrawerComponent;
